import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {ControlContainer, NgForm} from "@angular/forms";
import {ToastService} from "../../../../services/toast/toast.service";
import {ConteudoRim} from "../../../../core/conteudo-rim";
import {ObjectUtil} from "../../../../utils/object-util";
import {timer} from "rxjs";
import {LoadingPopupService} from "../../../../services/loadingPopup/loading-popup.service";
import {ConsultaBanco} from "../../../../core/consulta-banco";
import {ArquivoConteudoRimService} from "../../../../services/arquivo-conteudo-rim/arquivo-conteudo-rim.service";
import {FileUtils} from "../../../../utils/file-utils";

@Component({
    selector: "conteudo-rim",
    templateUrl: "./conteudo-rim.component.html",
    styleUrls: ["./conteudo-rim.component.css"],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
})
export class ConteudoRimComponent implements OnInit {

    @Input() subConteudo: boolean = false;
    @Input() listaConteudos: ConteudoRim[];
    @Input() conteudo: ConteudoRim;
    @Input() index: number;
    @Input() camposDesabilitados: boolean;
    @Input() consultasBanco: ConsultaBanco[];

    pinRandom = Math.random();

    isEditando = false;
    texto: string;
    url: any;

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService,
                private loadingPopupService: LoadingPopupService,
                private arquivoConteudoRimService: ArquivoConteudoRimService,
                private fileUtils: FileUtils) {
    }

    ngOnInit(): void {
        if (!this.conteudo.id) this.isEditando = true;
        this.recarregarTexto();
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    deletar() {
        this.listaConteudos.splice(this.index, 1);
        this.toastService.showSucesso("Conteúdo removida com sucesso.");
        this.listaConteudos.forEach((item, index) => item.posicao = index + 1);
    }

    onValorChangeConsultaBanco(registro: any) {
        this.conteudo.consultaBanco = registro;
    }

    onValorChangeTipoConteudoRim(registro: any) {
        this.conteudo.tipoConteudoRim = registro;
        this.conteudo.colunas = [];
        this.conteudo.cabecalhosTabela = [];
        this.conteudo.agruparTabela = true;

        if (!this.exibiBotaoSubConteudo())
            this.conteudo.subConteudos = [];
    }

    addSubConteudoRim() {
        if (!this.conteudo.subConteudos)
            this.conteudo.subConteudos = [];

        const conteudo: ConteudoRim = new ConteudoRim();
        conteudo.posicao = Math.max(0, ...this.conteudo.subConteudos.map(c => c.posicao)) + 1;
        conteudo.alinhamento = "L";
        this.conteudo.subConteudos.push(conteudo);
    }

    exibiCampo() {
        if (!this.conteudo.tipoConteudoRim)
            return false;

        return this.conteudo.tipoConteudoRim.id === 1 || this.conteudo.tipoConteudoRim.id === 2;
    }

    exibiValor() {
        if (!this.conteudo.tipoConteudoRim)
            return false;

        return this.conteudo.tipoConteudoRim.id === 1 || this.conteudo.tipoConteudoRim.id === 3;
    }

    exibiParagrafo() {
        if (!this.conteudo.tipoConteudoRim)
            return false;

        return this.conteudo.tipoConteudoRim.id === 4;
    }

    exibiBotaoSubConteudo() {
        if (!this.conteudo.tipoConteudoRim)
            return false;

        return !this.subConteudo && this.conteudo.tipoConteudoRim.id !== 5 && this.conteudo.tipoConteudoRim.id !== 6;
    }

    exibiTabela() {
        if (!this.conteudo.tipoConteudoRim)
            return false;

        return this.conteudo.tipoConteudoRim.id === 5;
    }

    exibiAnexo() {
        if (!this.conteudo.tipoConteudoRim)
            return false;

        return this.conteudo.tipoConteudoRim.id === 6;
    }

    exibirAlinhamento() {
        if (!this.conteudo.tipoConteudoRim)
            return false;

        return this.conteudo.tipoConteudoRim.id === 1 || this.conteudo.tipoConteudoRim.id === 2 || this.conteudo.tipoConteudoRim.id === 3;
    }

    onChangePosicao() {
        const inicioReordenacao = Date.now();
        this.loadingPopupService.mostrarMensagemDialog('Reordenando Conteúdos...');

        if (this.conteudo.posicao < 1)
            this.conteudo.posicao = 1;
        else if (this.conteudo.posicao > this.listaConteudos.length)
            this.conteudo.posicao = this.listaConteudos.length;

        const indexCapitulo = this.listaConteudos.findIndex(c => c === this.conteudo);
        ObjectUtil.reordenarLista(this.listaConteudos, indexCapitulo, this.conteudo.posicao - 1);
        this.listaConteudos.forEach((item, index) => item.posicao = index + 1);

        const tempoTotalReordenacao = Date.now() - inicioReordenacao;
        const tempoRestanteEspera = Math.max(500 - tempoTotalReordenacao, 0);

        timer(tempoRestanteEspera).subscribe(() => this.loadingPopupService.closeDialog());
    }

    changetEditando() {
        this.isEditando = !this.isEditando;
        this.recarregarTexto();
    }

    recarregarTexto() {
        if (this.exibiCampo() || this.exibiValor()) {
            this.gerarTextoCampoValor();
        } else if (this.exibiParagrafo()) {
            this.gerarTextoParagrafo();
        } else if (this.exibiAnexo()) {
            if (this.conteudo.id && !this.conteudo.isAnexoAlterado) {
                this.arquivoConteudoRimService.get(this.conteudo.id).subscribe(
                    (res) => {
                        let img = this.fileUtils.convertBufferArrayToBase64(res);
                        this.url = img;
                    },
                    (err) => {
                        this.toastService.showAlerta("Erro ao baixar arquivo!");
                    }
                );
            } else if (this.conteudo.isAnexoAlterado) {
                const reader = new FileReader();
                this.fileToArrayBuffer(this.conteudo.anexo).then((arrayBuffer) => {
                    this.url = this.fileUtils.convertBufferArrayToBase64(arrayBuffer);
                })
            }
        }
    }

    fileToArrayBuffer(file: File): Promise<ArrayBuffer> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onloadend = () => resolve(reader.result as ArrayBuffer);
            reader.onerror = error => reject(error);
        });
    }

    gerarTextoCampoValor() {
        let texto = this.conteudo.descricao || "";
        if (this.conteudo.descricaoBold)
            texto = "<b>" + texto + "</b>";
        if (this.conteudo.descricaoItalic)
            texto = "<i>" + texto + "</i>";

        if (this.conteudo.consultaBanco && this.consultasBanco) {
            let valor = this.consultasBanco.find(value => value.id === this.conteudo.consultaBanco.id).valor?.texto;
            if (this.conteudo.valorBold)
                valor = "<b>" + valor + "</b>";
            if (this.conteudo.valorItalic)
                valor = "<i>" + valor + "</i>";
            texto += texto !== "" ? " " + valor : valor;
        }

        this.texto = texto;
    }

    gerarTextoParagrafo() {
        this.texto = this.conteudo.descricao || "";

        if (this.consultasBanco) {
            let matches = [...new Set(this.texto.match(/#{(.*?)}/g) || [])];
            matches.forEach(match => {
                const key = match.slice(2, -1);
                const textoValor = this.consultasBanco.find(value => value.codigo === key).valor?.texto;
                this.texto = this.texto.replace(new RegExp(match, 'g'), textoValor);
            });
        }
    }

}
